import React from 'react';
import PropTypes from 'prop-types';

import { TranslatedMessage } from 'common/components/Intl';

const LoadingSplash = props => (
  <div className="LoadingSplash">
    <div className="Spinner--gray LoadingSplash__spinner" />
    {props.showText && (
      <div className="LoadingSplash__text">
        <TranslatedMessage id={'loading'} />
      </div>
    )}
  </div>
);

LoadingSplash.propTypes = {
  showText: PropTypes.bool,
};

LoadingSplash.defaultProps = {
  showText: true,
};

export default LoadingSplash;
